import React, { Component } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group"; // ES6
import Slider from "react-slick";

import { Arrow } from "../Utils/Functions";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      {Arrow}
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      {Arrow}
    </div>
  );
}

export default class WinnersTabs extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
    this.handleClickActiveTab = this.handleClickActiveTab.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.winners !== prevProps.winners) {
      this.setActiveSlideByDate();
    }
  }
  setActiveSlideByDate() {
    const today = new Date();
    let startingSlide = 0;
    this.props.winners &&
      Object.keys(this.props.winners).map((date, i) => {
        let dateArr = date?.split(".");
        dateArr[1] = dateArr[1] - 1;
        let dateWin = new Date(today.getFullYear(), dateArr[1], dateArr[0]);
        if (today > dateWin) {
          startingSlide++;
        }
      });
    this.setState(
      {
        activeTab: startingSlide > 0 ? startingSlide - 1 : 0,
      },
      () => this.slider.slickGoTo(startingSlide > 0 && startingSlide - 1, false)
    );
  }

  handleClickActiveTab(id) {
    const newActiveTab = id;
    this.setState({
      activeTab: newActiveTab,
    });
  }

  getWeekDayFirstLetter(day) {
    const { language } = this.props;
    if (language === "et") {
      return day === "tuesday" ? "T" : "R";
    } else {
      return day === "tuesday" ? "В" : "П";
    }
  }

  notDrawnText(day) {
    const { language } = this.props;
    return (
      <p>
        {language === "et"
          ? `Keno lisaloosimised toimuvad esmaspäeviti alates 09.09 kuni 28.10 eelnevaks nädalaks ostetud kombinatsioonide vahel.`
          : `Дополнительные розыгрыши KENO проводятся каждый понедельник с 09.09 по 28.10 между купленными на предыдущей неделе билетами.`}
      </p>
    );
  }

  renderWinnerList = (activeTab = 0) => {
    const { winners, language } = this.props;
    return Object.keys(winners).map((date, index) => {
      if (index === activeTab) {
        return (
          <div key={index}>
            {winners[date]["tickets"].length > 0 ? (
              <p>
                {language === "et"
                  ? `Selle loosimise võidupilet on:`
                  : `Выигрышный билет этого розыгрыша:`}
              </p>
            ) : (
              ""
            )}
            <ul className="winners--list">
              {winners[date]["tickets"].length > 0 ? (
                <>
                  {Object.keys(winners[date]["tickets"]).map((winner, key) => {
                    if (winners[date]["tickets"][winner]?.id_nr) {
                      return (
                        <li className="winners--item" key={key}>
                          <span className="winners--item__amount">
                            {/*this.formatNumber(
                              winners[date]["tickets"][winner]?.amount
                            )*/}{" "}
                            12 x 800 €
                          </span>{" "}
                          <span className="winners--item__id">
                            {winners[date]["tickets"][winner]?.id_nr}
                          </span>
                          <span className="winners--item__type">
                            {winners[date]["tickets"][winner].type}
                          </span>
                        </li>
                      );
                    }
                  })}
                </>
              ) : (
                this.notDrawnText(winners[date].day)
              )}
            </ul>

            {winners[date]["tickets"].length > 0 ? (
              <p>{language === "et" ? `` : ``}</p>
            ) : (
              ""
            )}
          </div>
        );
      }
    });
  };

  formatNumber(number) {
    const { language } = this.props;
    if (language === "ru" && number.length === 4) {
      return number.slice(0, 1) + " " + number.slice(1);
    }
    return number;
  }

  render() {
    const { language } = this.props;
    const settings = {
      dots: false,
      infinite: false,
      speed: 50,

      swipeToSlide: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      slidesToShow: 8,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 8,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 420,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 340,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    };
    const { winners } = this.props;
    const { activeTab } = this.state;
    if (winners) {
      return (
        <>
          <div className="winners--tabs">
            <Slider ref={(slider) => (this.slider = slider)} {...settings}>
              {Object.keys(winners).map((date, i) => {
                return (
                  <div
                    key={i}
                    className={`winners--tab ${
                      activeTab === i ? "is-active" : ""
                    }`}
                    onClick={() => this.handleClickActiveTab(i)}
                  >
                    <span className="winners--date">{` ${date}`}</span>
                  </div>
                );
              })}
            </Slider>
          </div>

          <div className="winners--tabContent">
            {this.renderWinnerList(activeTab)}
          </div>
        </>
      );
    } else {
      return <div className="winners--noWinners"></div>;
    }
  }
}
